import { render, staticRenderFns } from "./Neos.vue?vue&type=template&id=5dcb8a4c"
import script from "./Neos.vue?vue&type=script&lang=js"
export * from "./Neos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports